var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: _vm.svgColor,
        id: "Layer",
        height: _vm.width,
        viewBox: "0 0 24 24",
        width: _vm.width,
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          id: "credit-card-plus",
          d: "m11 17.25h-6c-1.577 0-2.25-.673-2.25-2.25v-5.25h16.5v.25a.75.75 0 0 0 1.5 0v-3a3.383 3.383 0 0 0 -3.75-3.75h-12a3.383 3.383 0 0 0 -3.75 3.75v8a3.383 3.383 0 0 0 3.75 3.75h6a.75.75 0 0 0 0-1.5zm-6-12.5h12c1.577 0 2.25.673 2.25 2.25v1.25h-16.5v-1.25c0-1.577.673-2.25 2.25-2.25zm4 8.5a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5zm11 3.75a.75.75 0 0 1 -.75.75h-.5v.5a.75.75 0 0 1 -1.5 0v-.5h-.5a.75.75 0 0 1 0-1.5h.5v-.5a.75.75 0 0 1 1.5 0v.5h.5a.75.75 0 0 1 .75.75zm-2-4.75a4.75 4.75 0 1 0 4.75 4.75 4.756 4.756 0 0 0 -4.75-4.75zm0 8a3.25 3.25 0 1 1 3.25-3.25 3.254 3.254 0 0 1 -3.25 3.25z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }